// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParsedFormResult } from './parsed-form-result';
import {
    ParsedFormResultFromJSON,
    ParsedFormResultFromJSONTyped,
    ParsedFormResultToJSON,
    ParsedFormResultToJSONTyped,
} from './parsed-form-result';

/**
 * 
 * @export
 * @interface UploadResponse
 */
export interface UploadResponse {
    /**
     * 
     * @type {Array<ParsedFormResult>}
     * @memberof UploadResponse
     */
    forms?: Array<ParsedFormResult>;
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    job_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    parser_label?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    pipeline: UploadResponsePipelineEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadResponse
     */
    study_id: string;
    /**
     * 
     * @type {number}
     * @memberof UploadResponse
     */
    total_codelists?: number;
    /**
     * 
     * @type {number}
     * @memberof UploadResponse
     */
    total_forms?: number;
    /**
     * 
     * @type {number}
     * @memberof UploadResponse
     */
    total_rules?: number;
}


/**
 * @export
 */
export const UploadResponsePipelineEnum = {
    Specification: 'specification',
    Extraction: 'extraction'
} as const;
export type UploadResponsePipelineEnum = typeof UploadResponsePipelineEnum[keyof typeof UploadResponsePipelineEnum];


/**
 * Check if a given object implements the UploadResponse interface.
 */
export function instanceOfUploadResponse(value: object): value is UploadResponse {
    if (!('pipeline' in value) || value['pipeline'] === undefined) return false;
    if (!('study_id' in value) || value['study_id'] === undefined) return false;
    return true;
}

export function UploadResponseFromJSON(json: any): UploadResponse {
    return UploadResponseFromJSONTyped(json, false);
}

export function UploadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'forms': json['forms'] == null ? undefined : ((json['forms'] as Array<any>).map(ParsedFormResultFromJSON)),
        'job_id': json['job_id'] == null ? undefined : json['job_id'],
        'message': json['message'] == null ? undefined : json['message'],
        'parser_label': json['parser_label'] == null ? undefined : json['parser_label'],
        'pipeline': json['pipeline'],
        'study_id': json['study_id'],
        'total_codelists': json['total_codelists'] == null ? undefined : json['total_codelists'],
        'total_forms': json['total_forms'] == null ? undefined : json['total_forms'],
        'total_rules': json['total_rules'] == null ? undefined : json['total_rules'],
    };
}

export function UploadResponseToJSON(json: any): UploadResponse {
    return UploadResponseToJSONTyped(json, false);
}

export function UploadResponseToJSONTyped(value?: UploadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'forms': value['forms'] == null ? undefined : ((value['forms'] as Array<any>).map(ParsedFormResultToJSON)),
        'job_id': value['job_id'],
        'message': value['message'],
        'parser_label': value['parser_label'],
        'pipeline': value['pipeline'],
        'study_id': value['study_id'],
        'total_codelists': value['total_codelists'],
        'total_forms': value['total_forms'],
        'total_rules': value['total_rules'],
    };
}
